/**
 * Contiene le informazioni sull'environment di runtime
 *
 * tenant: il codice del tenant con cui è registrata la configurazione sul config server ui
 * env: dev,test o prod per le pwa oppure app per l'app mobile
 * version: il numero di versione del pacchetto nel caso dell'app mobile
 */
export class Env {

    private constructor(public mode: string
        , public tenant: string
        , public env: string
        , public version?: string
        , public extBaseUrl?: string) {
    }

    public static forApp(tenant: string, version: string) {
        return new this( 'APP', tenant, 'app', version );
    }

    public static forPWA(tenant: string, env: string, version: string, extBaseUrl: string) {
        return new this('PWA', tenant, env, version, extBaseUrl);
    }

    public isAPP(): boolean {
        return this.mode === 'APP';
    }

    public isPWA(): boolean {
        return this.mode === 'PWA';
    }

    public getExtBaseUrl(): string {
        return this.extBaseUrl;
    }

    /**
     * ritorna una stringa con info sull'env corrente utile per log o da mettere a video
     */
    public getInfo(): string {
        if (this.version) {
            return `[mode: ${this.mode}, tenant: ${this.tenant}, env: ${this.env}, version: ${this.version}] `;
        } else {
            return `[mode: ${this.mode}, tenant: ${this.tenant}, env: ${this.env}] `;
        }
    }
}
